export default __webpack_public_path__ + "static/media/button-evolve.46a08f12.png";